module.exports = __webpack_public_path__ + "static/media/child.94dfb34c.webp";